import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { globalStyles } from './style/gstheme';
import PropTypes from 'prop-types';

const styles = theme => {
  return Object.assign({
    actionText: {
      textAlign: 'center',
      fontSize: '16px',
      color: '#212121'
    },
    actionTextWrap: {
      display: 'inline-block',
      backgroundColor: 'rgb(2, 128, 144, 0.1)',
      borderRadius: '24px',
      padding: '12px 24px'
    }
  }, globalStyles);
};

class ActionText extends React.Component {

  render() {

    const { classes, children, offset, dataTest, bottom, format } = this.props;

    return (
      <div style={{ marginTop: offset, marginBottom: bottom, textAlign: 'center' }}>
        <span
          className={classes.actionTextWrap}
          style={{
            ...(format === "result") && {

              backgroundColor: 'rgb(221, 44, 0, 0.1)'
            },
            ...(format === "none" || format === "status") && {
              backgroundColor: 'transparent',
              padding: '0px'
            }
          }}>
          <Typography
            role={format === "status" ? "status" : null}
            data-test={dataTest || "action-text"}
            className={classes.actionText}>
            <span>
              {children}
            </span>
          </Typography>
        </span>
      </div>
    );
  }
}

ActionText.defaultProps = {
  offset: '0px',
  bottom: '0px'
};

ActionText.propTypes = {
  offset: PropTypes.string.isRequired,
  classes: PropTypes.object,
  bottom: PropTypes.string,
  format: PropTypes.string,
  children: PropTypes.any,
  dataTest: PropTypes.string,
};

export default withStyles(styles)(ActionText);